/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section1_P2Inputs */

const en_privacy_section1_p2 = /** @type {(inputs: Privacy_Section1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We believe that developer tools should respect user privacy by default. PureJSON was designed from the ground up to ensure that sensitive data: such as API keys, configuration files, and production data: remains completely under your control.`)
};

const ko_privacy_section1_p2 = /** @type {(inputs: Privacy_Section1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개발자 도구는 기본적으로 사용자 프라이버시를 존중해야 한다고 생각합니다. PureJSON은 API 키, 설정 파일, 프로덕션 데이터와 같은 민감한 정보가 완전히 사용자의 통제 하에 있도록 처음부터 설계되었습니다.`)
};

const ja_privacy_section1_p2 = /** @type {(inputs: Privacy_Section1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発者ツールはデフォルトでユーザーのプライバシーを尊重すべきだと考えています。PureJSONは、APIキー、設定ファイル、本番データなどの機密情報が完全にユーザーの管理下にあるよう、ゼロから設計されました。`)
};

/**
* | output |
* | --- |
* | "We believe that developer tools should respect user privacy by default. PureJSON was designed from the ground up to ensure that sensitive data: such as API k..." |
*
* @param {Privacy_Section1_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section1_p2 = /** @type {((inputs?: Privacy_Section1_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section1_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section1_p2(inputs)
	if (locale === "ko") return ko_privacy_section1_p2(inputs)
	return ja_privacy_section1_p2(inputs)
});